import * as React from "react"
import { useTranslation } from "react-i18next"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import StatefulField from "shared/components/StatefulField"
import useEditor from "shared/hooks/useEditor"
import useHandleImageUpload from "shared/hooks/useHandleImageUpload"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICategory, ICategoryOrProduct, IProduct } from "shared/hubrise/models"

import Commands from "./Commands"

const CategoryContent = ({ category }: { category: ICategory }): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()

  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()
  const handleImageUpload = useHandleImageUpload()

  const handleChange =
    <TField extends keyof ICategoryOrProduct>(field: TField, options?: { collapse?: boolean }) =>
    (value: (ICategory & IProduct)[TField]) =>
      editor.categoryOrProduct.update(category, field, value, options)

  return (
    <>
      <Details.Topbar
        commands={<Commands categoryOrProduct={category} />}
        onClose={() => navigate(catalogNavigation.editPath("products"))}
      >
        <StatefulField.Title
          name="category-name"
          initialValue={category.name}
          placeholder={t("product.name.placeholder.category")}
          onChange={handleChange("name")}
          validate={(name) => (name.length === 0 ? t("validations.not_empty") : undefined)}
        />
      </Details.Topbar>

      <StatefulField.TextEditor
        name="category-description"
        initialValue={category.description}
        label={t("product.description.label")}
        withMargin
        placeholder={t("product.description.placeholder.category")}
        onChange={handleChange("description")}
      />

      <StatefulField.ImagesHolder
        name="category-images"
        initialValue={category.imageHrIds}
        label={t("product.images")}
        withMargin
        onChange={handleChange("imageHrIds", { collapse: false })}
        onUpload={handleImageUpload}
        imagePathResolver={(imageHrId) => catalogNavigation.imagePath(imageHrId)}
        modalTitle={category.name}
      />
    </>
  )
}

export default CategoryContent
